module.exports = __webpack_public_path__ + "img/icon-Cal-Office365.849a5dba.png";